import { Injectable } from '@angular/core';
/**Clase para manejo default del aplicativp */
@Injectable()
export class AppGpSettings {
  /**
   * Estado exitoso de servicio
   */
  static STATUS_RESPONSE_SUCCESS = "SCF000";
  /**
   * Estado de respuesta de canal reactivado
   */
  static STATUS_RESPONSE_CHANNEL_DEACTIVATED = "MSCS04";
  /**
   * id de canal
   */
  static CHANNELID = "STAE";
  /**
   * ruta source
   */
  static SOURCE = "/apita";
  /**
   *ruta por default
   */
  static URL_ROOT = "/captura";
  /**
   * path token validate
   */
  static PATH_TOKEN = "/SSO/validate";
  /**
   * Parametros a modificar para pruebas
   */
  /**
   * url a consumir  #Variable para probar en ambientes (Modificar para probar en ambiente desarrollo)
   */
  // static URL= "https://ta.santander.com.mx"
  static URL = "http://localhost:3000"

  /**
   * ambiente a direccionar
   */
  static ENV_VAR = "pro";

  static ENV_TAGGEO = "pro";
}
